import { render, staticRenderFns } from "./Card-Action.vue?vue&type=template&id=6b8c2cec&scoped=true"
import script from "./Card-Action.vue?vue&type=script&lang=js"
export * from "./Card-Action.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8c2cec",
  null
  
)

export default component.exports